import { OrderBulkDto } from '@tiendanube/common';
import {
  nuvemEnvioCarriers,
  nuvemEnvioLabelsAppLinkPrefixes,
} from './pages/constants';
import { NUVEM_ENVIO_ORDERS_ROUTES } from './routes';
import { NE_PRINT_LABEL_SOURCE } from '../constants';

type BuildPrintNuvemEnvioLabelPathProps =
  | BuildPrintNuvemEnvioLabelPathFromOrdersListProps
  | BuildPrintNuvemEnvioLabelPathFromOrderDetailsProps;

type BuildPrintNuvemEnvioLabelPathFromOrdersListProps = {
  source: NE_PRINT_LABEL_SOURCE.ORDERS_LIST;
  fulfillmentOrdersIds: string[];
};

type BuildPrintNuvemEnvioLabelPathFromOrderDetailsProps = {
  source: NE_PRINT_LABEL_SOURCE.ORDER_DETAILS;
  orderId: string;
  fulfillmentOrdersIds: string[];
};

const isNuvemEnvioLink = (link: string) =>
  nuvemEnvioLabelsAppLinkPrefixes.some((substring) => link.includes(substring));

const isNuvemEnvioPrintLabelAvailable = (carrier: string) =>
  nuvemEnvioCarriers.some((substring) => carrier.includes(substring));

const generateCallbackUrl = (props: BuildPrintNuvemEnvioLabelPathProps) =>
  `/admin/v2${buildPrintNuvemEnvioLabelPath(props)}`;

function buildPrintNuvemEnvioLabelPath(
  props: BuildPrintNuvemEnvioLabelPathProps,
) {
  let callbackUrl = `${
    NUVEM_ENVIO_ORDERS_ROUTES.ordersNuvemEnvioPrintLabelStatus
  }?ids=${props.fulfillmentOrdersIds.join(',')}&source=${props.source}`;

  if (props.source === NE_PRINT_LABEL_SOURCE.ORDER_DETAILS) {
    callbackUrl += `&orderId=${props.orderId}`;
  }

  return callbackUrl;
}

function extractFulfillmentOrdersIds(
  selectedRowsId: string[],
  bulkOrders: OrderBulkDto[],
) {
  return bulkOrders
    .filter((order) => selectedRowsId.includes(order.orderId))
    .flatMap((order) =>
      order.fulfillments.map((fulfillment) => fulfillment.fulfillmentId),
    )
    .slice(0, 50);
}

export {
  isNuvemEnvioLink,
  isNuvemEnvioPrintLabelAvailable,
  generateCallbackUrl,
  extractFulfillmentOrdersIds,
  buildPrintNuvemEnvioLabelPath,
};
